import { useAuthStore } from '@/stores/auth-store';
import { queryClient } from './query-client';
import { setUnauthorizedHandler } from './session';

/**
 * Une las tres piezas del manejo de 401: cliente HTTP → sesión → caché.
 *
 * Se llama UNA sola vez desde `main.tsx`, antes de renderizar, para que cualquier 401
 * (que venga de una query, de una mutación o de una petición suelta) tenga el mismo efecto:
 *   1. borra el token/usuario/tenants del store persistido,
 *   2. vacía la caché de TanStack Query (evita mostrar datos del usuario anterior),
 *   3. las rutas protegidas (`RequireAuth`) ven que no hay token y redirigen a /login.
 */
export function registerSessionGuard(): void {
  setUnauthorizedHandler(() => {
    useAuthStore.getState().clearSession();
    queryClient.clear();
  });
}
